import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './style.scss'

const PostItemSkeleton = () => {
  return (
    <div className="PostItemSkeleton">
      <div>
        <Skeleton circle width={60} height={60} />
      </div>
      <div className="PostItemSkeleton__center">
        <Skeleton width={70} />
        <Skeleton height={60} />
        <Skeleton height={25} width={120} />
      </div>
    </div>
  )
}

export default PostItemSkeleton
